export const COMMON_SELECT_LIST_ITEM_TRADE_ASYNC = 'COMMON_SELECT_LIST_ITEM_TRADE_ASYNC';
export const COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS = 'COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS';
export const COMMON_SELECT_LIST_ITEM_TO_REPAIR_ASYNC = 'COMMON_SELECT_LIST_ITEM_TO_REPAIR_ASYNC';
export const COMMON_SELECT_LIST_ITEM_TO_REPAIR_SUCCESS = 'COMMON_SELECT_LIST_ITEM_TO_REPAIR_SUCCESS';
export const COMMON_SELECT_LIST_ITEM_TO_REPAIR_BY_TRADE_ID_ASYNC = 'COMMON_SELECT_LIST_ITEM_TO_REPAIR_BY_TRADE_ID_ASYNC';
export const COMMON_SELECT_LIST_ITEM_TO_REPAIR_BY_TRADE_ID_SUCCESS = 'COMMON_SELECT_LIST_ITEM_TO_REPAIR_BY_TRADE_ID_SUCCESS';
export const COMMON_SELECT_LIST_PROBLEM_BY_ITEM_REPAIR_ID_ASYNC = 'COMMON_SELECT_LIST_PROBLEM_BY_ITEM_REPAIR_ID_ASYNC';
export const COMMON_SELECT_LIST_PROBLEM_BY_ITEM_REPAIR_ID_SUCCESS = 'COMMON_SELECT_LIST_PROBLEM_BY_ITEM_REPAIR_ID_SUCCESS';
export const COMMON_SELECT_LIST_REGION_ASYNC = 'COMMON_SELECT_LIST_REGION_ASYNC';
export const COMMON_SELECT_LIST_REGION_SUCCESS = 'COMMON_SELECT_LIST_REGION_SUCCESS';
export const COMMON_SELECT_LIST_MARKET_ASYNC = 'COMMON_SELECT_LIST_MARKET_ASYNC';
export const COMMON_SELECT_LIST_MARKET_BY_REGION_ID_ASYNC = 'COMMON_SELECT_LIST_MARKET_BY_REGION_ID_ASYNC';
export const COMMON_SELECT_LIST_MARKET_SUCCESS = 'COMMON_SELECT_LIST_MARKET_SUCCESS';
export const COMMON_SELECT_LIST_ACCOUNT_ASYNC = 'COMMON_SELECT_LIST_ACCOUNT_ASYNC';
export const COMMON_SELECT_LIST_ACCOUNT_SUCCESS = 'COMMON_SELECT_LIST_ACCOUNT_SUCCESS';
export const COMMON_SELECT_LIST_PHASE_BY_PROJECT_ID_ASYNC = 'COMMON_SELECT_LIST_PHASE_BY_PROJECT_ID_ASYNC';
export const COMMON_SELECT_LIST_PHASE_SUCCESS = 'COMMON_SELECT_LIST_PHASE_SUCCESS';
export const COMMON_SELECT_LIST_MODEL_BY_PROJECT_ID_ASYNC = 'COMMON_SELECT_LIST_MODEL_BY_PROJECT_ID_ASYNC';
export const COMMON_SELECT_LIST_MODEL_SUCCESS = 'COMMON_SELECT_LIST_MODEL_SUCCESS';
export const COMMON_SELECT_LIST_SUBCONTRACTOR_ASYNC = 'COMMON_SELECT_LIST_SUBCONTRACTOR_ASYNC';
export const COMMON_SELECT_LIST_SUBCONTRACTOR_SUCCESS = 'COMMON_SELECT_LIST_SUBCONTRACTOR_SUCCESS';
export const COMMON_SELECT_LIST_ROOM_ASYNC = 'COMMON_SELECT_LIST_ROOM_ASYNC';
export const COMMON_SELECT_LIST_ROOM_SUCCESS = 'COMMON_SELECT_LIST_ROOM_SUCCESS';
export const COMMON_SELECT_LIST_PROJECT_ASYNC = 'COMMON_SELECT_LIST_PROJECT_ASYNC';
export const COMMON_SELECT_LIST_PROJECT_SUCCESS = 'COMMON_SELECT_LIST_PROJECT_SUCCESS';
export const COMMON_SELECT_LIST_REQUEST_TYPES_ASYNC = 'COMMON_SELECT_LIST_REQUEST_TYPES_ASYNC';
export const COMMON_SELECT_LIST_REQUEST_TYPES_SUCCESS = 'COMMON_SELECT_LIST_REQUEST_TYPES_SUCCESS';
export const COMMON_SELECT_LIST_WORK_ORDER_TYPES_ASYNC = 'COMMON_SELECT_LIST_WORK_ORDER_TYPES_ASYNC';
export const COMMON_SELECT_LIST_WORK_ORDER_TYPES_SUCCESS = 'COMMON_SELECT_LIST_WORK_ORDER_TYPES_SUCCESS';
export const COMMON_SELECT_LIST_LOT_ASYNC = 'COMMON_SELECT_LIST_LOT_ASYNC';
export const COMMON_SELECT_LIST_LOT_SUCCESS = 'COMMON_SELECT_LIST_LOT_SUCCESS';
export const COMMON_SELECT_LIST_INSURANCE_ASYNC = 'COMMON_SELECT_LIST_INSURANCE_ASYNC';
export const COMMON_SELECT_LIST_INSURANCE_SUCCESS = 'COMMON_SELECT_LIST_INSURANCE_SUCCESS';

//UPLOAD FILE TO S3
export const COMMON_SETUP_AWS_ASYNC = 'COMMON_SETUP_AWS_ASYNC';
export const COMMON_UPLOAD_FILE_TO_S3_ASYNC = 'COMMON_UPLOAD_FILE_TO_S3_ASYNC';
export const COMMON_UPLOAD_FILE_TO_S3_HOME_INVENTORY_ASYNC = 'COMMON_UPLOAD_FILE_TO_S3_HOME_INVENTORY_ASYNC';

export const COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC = 'COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC';
export const COMMON_UPLOAD_MULTI_SIGNATURE_TO_S3_ASYNC = 'COMMON_UPLOAD_MULTI_SIGNATURE_TO_S3_ASYNC';




// WEBPACK FOOTER //
// ./src/Common/constants.js